import angular from "angular";

import {
  vsServiceName as PartTransactionDetailComponentServiceName,
  PartTransactionDetailComponentServiceProvider,
  vsDirectiveName as PartTransactionDetailComponentDirectiveName,
  partTransactionDetailDirective,
  partTransactionDetailConfig,
} from ".";

import {
  vsComponentName as partLocationComponentName,
  partTransactionDetailPartLocationComponent,
} from "./items/partLocation";
import {
  partTransactionDetailCheckedOutPartComponent,
  vsComponentName as partTransactionDetailCheckedOutPartComponentName,
} from "./items/checkedOutPart";
import {
  partTransactionDetailMachinePartComponent,
  vsComponentName as partTransactionDetailMachinePartComponentName,
} from "./items/machinePart";
import {
  partTransactionDetailPartOrderItemComponent,
  vsComponentName as partTransactionDetailPartOrderItemComponentName,
} from "./items/partOrderItem";
import {
  partTransactionDetailVoidPartLocationItemComponent,
  vsComponentName as partTransactionDetailVoidPartLocationItemComponentName,
} from "./items/voidPartLocation";

export const vsModuleName = "partTransactionDetailModule";

angular
  .module(vsModuleName, [])
  .provider(
    PartTransactionDetailComponentServiceName,
    PartTransactionDetailComponentServiceProvider
  )
  .directive(
    PartTransactionDetailComponentDirectiveName,
    partTransactionDetailDirective
  )
  .component(
    partLocationComponentName,
    partTransactionDetailPartLocationComponent
  )
  .component(
    partTransactionDetailCheckedOutPartComponentName,
    partTransactionDetailCheckedOutPartComponent
  )
  .component(
    partTransactionDetailMachinePartComponentName,
    partTransactionDetailMachinePartComponent
  )
  .component(
    partTransactionDetailPartOrderItemComponentName,
    partTransactionDetailPartOrderItemComponent
  )
  .component(
    partTransactionDetailVoidPartLocationItemComponentName,
    partTransactionDetailVoidPartLocationItemComponent
  )
  .config(partTransactionDetailConfig);
